module.exports = __webpack_public_path__ + "static/media/6-solution-2.85d31f2c.mp3";